<template>
    <div v-if="hasAccessDelete(FUNCTIONALITY)">
        <loader :loading="isLoading" v-if="isLoading"></loader>
        <div v-for="forecast in forecasts" :key="forecast.id">
            <input
                :id="'forecast_' + forecast.id"
                :checked="forecastItemMap.get(forecast.id)"
                @change="forecastItemMap.set(forecast.id, !forecastItemMap.get(forecast.id));"
                type="checkbox"
                :disabled="isDisabled(forecast)"
            />
            <label class="cutWordM" :for="'forecast_' + forecast.id">{{ forecast.name }}</label>
        </div>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { FUNCTIONALITY } from "@/components/forecasts/constants";
import ForecastValidator from "@/components/forecasts/validation/forecastValidator";
import loader from "@/components/loader/loader";
import historyService from "@/services/history";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        doSave: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    components: {
        loader
    },
    data() {
        return {
            FUNCTIONALITY,
            forecastItemMap: new Map(),
            originalForecastItemMap: null,
            ForecastValidator,
            isLoading: false
        };
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    computed: {
        ...mapGetters("forecast", { forecastsModifiable: "itemsModifiable" }),
        ...mapGetters("forecast", { getItems: "getItemsShallow" }),
        forecasts() {
            return this.forecastsModifiable.filter(fc => ForecastValidator.canAddItem(fc, [], this.item));
        }
    },
    watch: {
        doSave: function() {
            if (this.doSave) {
                this.save();
            }
        }
    },
    methods: {
        ...mapActions("forecast", { updateItems: "updateItems" }),
        ...mapActions("forecast", { populateItems: "populateItemsShallow" }),
        ...mapActions("forecast", { populateForecasts: "populate" }),
        async forecastContainsItem(forecast) {
            let items = this.getItems(forecast.id);
            return items.some(itemInForecast => itemInForecast.id === this.item.id);
        },
        async init() {
            await this.populateForecasts();
            await this.populateItems();
            for (let forecast of this.forecasts) {
                let contains = await this.forecastContainsItem(forecast);
                this.forecastItemMap.set(forecast.id, contains);
            }
            this.originalForecastItemMap = new Map(this.forecastItemMap);
        },
        async save() {
            for (const [key, value] of this.forecastItemMap.entries()) {
                if (value !== this.originalForecastItemMap.get(key)) {
                    let forecastToUpdate = this.forecasts.find(forecast => forecast.id === key);
                    if (value) {
                        await this.addItem(forecastToUpdate);
                    } else {
                        await this.removeItem(forecastToUpdate);
                    }
                }
            }
            this.dialogSuccess(`Forecast has been updated`);
            this.$emit("saved");
        },
        async addItem(forecast) {
            this.isLoading = true;
            await this.updateItems({ forecast, itemsToAdd: [this.item] })
                .then(() => {
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$swal({
                        text: "ERROR TO ADD FORECAST",
                        type: "error",
                        confirmButtonText: "OK",
                        confirmButtonColor: "rgb(135, 135, 135)",
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });
                });
        },

        async removeItem(forecast) {
            this.isLoading = true;
            await this.updateItems({ forecast, itemsToRemove: [this.item] })
                .then(() => {
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$swal({
                        text: "ERROR TO REMOVE FORECAST",
                        type: "error",
                        confirmButtonText: "OK",
                        confirmButtonColor: "rgb(135, 135, 135)",
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });
                });
        },
        isDisabled(forecast) {
            if (this.forecastItemMap.get(forecast.id)) {
                return !ForecastValidator.canRemoveItem(forecast, this.item);
            } else {
                return false;
            }
        }
    }
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// CatalogueItemManager.vue?70e06a6a